import React from 'react';
import '../../styles/Pagination.css';

const Pagination = ({ currentPage, totalPages, onPageChange, totalRecords, docked = false }) => {
  const pageCount = Math.max(1, totalPages);
  const page = Math.min(Math.max(1, currentPage), pageCount);
  const visiblePages = new Set([1, pageCount]);

  for (let number = Math.max(1, page - 2); number <= Math.min(pageCount, page + 2); number += 1) {
    visiblePages.add(number);
  }

  const pages = [...visiblePages].sort((a, b) => a - b).reduce((items, number, index, numbers) => {
    if (index > 0 && number - numbers[index - 1] > 1) items.push(`ellipsis-${number}`);
    items.push(number);
    return items;
  }, []);

  return (
    <nav className={`report-pagination${docked ? ' report-pagination--docked' : ''}`} aria-label="Table pagination">
      <div className="report-pagination__controls">
        {typeof totalRecords === 'number' && (
          <span className="report-pagination__total">Total Records: {totalRecords}</span>
        )}
        <button type="button" onClick={() => onPageChange(1)} disabled={page <= 1}>First</button>
        <button type="button" onClick={() => onPageChange(page - 1)} disabled={page <= 1}>Prev</button>
        {pages.map((number) => typeof number === 'string' ? (
          <span key={number} className="report-pagination__ellipsis" aria-hidden="true">…</span>
        ) : (
          <button
            type="button"
            key={number}
            onClick={() => onPageChange(number)}
            aria-label={`Page ${number}`}
            aria-current={number === page ? 'page' : undefined}
          >
            {number}
          </button>
        ))}
        <button type="button" onClick={() => onPageChange(page + 1)} disabled={page >= pageCount}>Next</button>
        <button type="button" onClick={() => onPageChange(pageCount)} disabled={page >= pageCount}>Last</button>
      </div>
    </nav>
  );
};

export default Pagination;
